/**
 * Formatta il numero fattura completo con sezionale e padding a 5 cifre.
 * 
 * Esempi:
 *   formatNuf('GP', 2)    → "GP-00002"
 *   formatNuf('GP', 438)  → "GP-00438"
 *   formatNuf('A', 1)     → "A-00001"
 *   formatNuf(null, 123)  → "123"       (backward compat)
 *   formatNuf('', 456)    → "456"       (backward compat)
 * 
 * @param {string|null} sezionale - Prefisso sezionale (es. "GP", "A")
 * @param {number|string} nuf - Numero progressivo fattura
 * @returns {string} Numero fattura formattato
 */
export const formatNuf = (sezionale, nuf) => {
  const num = parseInt(nuf);
  if (!Number.isFinite(num)) return String(nuf || '-');
  
  if (sezionale && sezionale.trim()) {
    return `${sezionale.trim().toUpperCase()}-${String(num).padStart(5, '0')}`;
  }
  return String(num);
};
